// extracted by mini-css-extract-plugin
export var copy_body = "contents-module--copy_body--1802a";
export var copy_cta = "contents-module--copy_cta--9880e";
export var from_capts = "contents-module--from_capts--a3055";
export var from_ovrly = "contents-module--from_ovrly--fb1cb";
export var from_two = "contents-module--from_two--f1ab1";
export var hsubtitle = "contents-module--hsubtitle--9b06a";
export var htitle = "contents-module--htitle--0b412";
export var htitle_link = "contents-module--htitle_link--56151";
export var img_title = "contents-module--img_title--e0ed2";
export var title = "contents-module--title--a1615";
export var use_caslon = "contents-module--use_caslon--ce80b";
export var use_mason = "contents-module--use_mason--1f529";
export var use_proxw = "contents-module--use_proxw--76aad";